import { Box, ButtonBase, Typography } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as ActiveHomerIcon } from "../../assets/icons/navigation/active-home.svg";
import { ReactComponent as InactiveHomerIcon } from "../../assets/icons/navigation/inactive-home.svg";
import { ReactComponent as ActiveUserIcon } from "../../assets/icons/navigation/active-user.svg";
import { ReactComponent as InactiveUserIcon } from "../../assets/icons/navigation/inactive-user.svg";
import { ReactComponent as ActiveInvestmentIcon } from "../../assets/icons/navigation/active-investment.svg";
import { ReactComponent as InactiveInvestmentIcon } from "../../assets/icons/navigation/inactive-investment.svg";
import { ReactComponent as ActiveAssetsIcon } from "../../assets/icons/navigation/active-assets.svg";
import { ReactComponent as InactiveAssetsIcon } from "../../assets/icons/navigation/inactive-assets.svg";

function AppNavigationContainer() {
  const location = useLocation();
  const navigate = useNavigate();

  const isHomeActive = () => location.pathname.includes("home");
  const isUserActive = () => location.pathname.includes("profile");
  const isAssetsActive = () => location.pathname.includes("assets");
  const isInvestmentActive = () => location.pathname.includes("investment");

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      <Outlet />
      <Box
        sx={{
          width: "100%",
          maxWidth: 600,
          minHeight: 56,
          display: "flex",
          alignItems: "center",
          boxShadow: (theme) => theme.shadows[4],
          bgcolor: "common.white",
          position: "sticky",
          pb: `env(safe-area-inset-bottom)`,
        }}
      >
        {[
          {
            label: "خانه",
            icon: isHomeActive() ? (
              <ActiveHomerIcon width={15} height={18} />
            ) : (
              <InactiveHomerIcon width={15} height={18} />
            ),
            color: isHomeActive() ? "primary.main" : "grey.3",
            link: "/app/navigation/home",
          },
          {
            label: "دارایی",
            icon: isAssetsActive() ? (
              <ActiveAssetsIcon width={18} height={18} />
            ) : (
              <InactiveAssetsIcon width={18} height={18} />
            ),
            color: isAssetsActive() ? "primary.main" : "grey.3",
            link: "/app/navigation/assets",
          },
          {
            label: "سرمایه‌گذاری",
            icon: isInvestmentActive() ? (
              <ActiveInvestmentIcon width={18} height={18} />
            ) : (
              <InactiveInvestmentIcon width={18} height={18} />
            ),
            color: isInvestmentActive() ? "primary.main" : "grey.3",
            link: "/app/navigation/investment",
          },
          {
            label: "حساب کاربری",
            icon: isUserActive() ? (
              <ActiveUserIcon width={15} height={18} />
            ) : (
              <InactiveUserIcon width={15} height={18} />
            ),
            color: isUserActive() ? "primary.main" : "grey.3",
            link: "/app/navigation/profile",
          },
        ].map((item) => {
          return (
            <ButtonBase
              key={item.label}
              onClick={() => {
                if (!location.pathname.includes(item.link)) {
                  navigate(item.link);
                }
              }}
              sx={{
                flex: 1,
                height: 56,
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {item.icon}
                <Typography
                  sx={{
                    mt: "6px",
                    fontSize: "10px",
                    color: item.color,
                  }}
                >
                  {item.label}
                </Typography>
              </Box>
            </ButtonBase>
          );
        })}
      </Box>
    </Box>
  );
}

export default AppNavigationContainer;
